import React, { VFC } from 'react';
import styled, { css } from 'styled-components';
import { omit } from 'rambda';
import { Input as AntdInput, InputProps as AntdInputProps } from 'antd';
import Group from 'antd/lib/input/Group';
import Search from 'antd/lib/input/Search';
import TextArea from 'antd/lib/input/TextArea';
import Password from 'antd/lib/input/Password';
import { StrictOmit } from '@enmon/commons';
import { Suffix } from '../Suffix/Suffix';

interface InputProps extends AntdInputProps {
  suffix?: string;
}

type StyledInputProps = StrictOmit<InputProps, 'suffix'> & { $hasSuffix: boolean };

const StyledInput = styled(AntdInput)<StyledInputProps>`
  font-size: 18px;
  border-radius: 4px 4px 4px 4px;

  ${({ $hasSuffix }) =>
    $hasSuffix &&
    css`
      border-right: 0px;
      border-radius: 4px 0px 0px 4px;
    `}

  .ant-input-lg {
    ${({ $hasSuffix }) =>
      $hasSuffix &&
      css`
        border-right: 0px;
        border-radius: 4px 0px 0px 4px;
      `}
  }
`;

interface InputComponents extends VFC<InputProps> {
  Group: typeof Group;
  Search: typeof Search;
  TextArea: typeof TextArea;
  Password: typeof Password;
}

export const Input: InputComponents = props => {
  const { suffix } = props;

  const customProps = omit(['suffix'], props);

  return (
    <div style={{ display: 'flex', flexGrow: 1 }}>
      <StyledInput $hasSuffix={Boolean(suffix)} {...customProps} />
      {suffix && <Suffix value={suffix} />}
    </div>
  );
};

Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
